<template>
  <div class="fin-kartica">

    <!-- Uvijek vidljivo: ono sto se doista gleda. -->
    <div class="par">
      <span class="k">{{lang.documentTotalAmountNetto}}</span>
      <span class="v">{{documentTotalAmountNetto}}</span>
    </div>
    <div class="par" v-if="pNum(documentTotalAmountDirectD1) !== 0">
      <span class="k">{{lang.documentTotalAmountDirectD1}}</span>
      <span class="v">{{documentTotalAmountDirectD1}}</span>
    </div>
    <div class="par">
      <span class="k">{{lang.documentTotalAmountVAT}}</span>
      <span class="v">{{documentTotalAmountVAT}}</span>
    </div>
    <div class="par zbroj jako">
      <span class="k">{{lang.documentTotalAmountBrutto}}</span>
      <span class="v">{{documentTotalAmountBrutto}} {{document.documentHomeCurrency}}</span>
    </div>
    <div class="par" v-if="docSide !== 1 && pNum(documentTotalAmountPayInAdvance) !== 0">
      <span class="k">{{lang.documentTotalAmountPayInAdvance}}</span>
      <span class="v">{{documentTotalAmountPayInAdvance}}</span>
    </div>
    <div class="par jako" v-if="docSide != 1">
      <span class="k">{{lang.documentTotalAmountToPay}}</span>
      <span class="v">{{documentTotalAmountToPay}} {{document.documentHomeCurrency}}</span>
    </div>

    <div class="banka" v-if="document.bankAccountName || document.bankAccountNr">
      {{document.bankAccountName}}<span v-if="document.bankAccountNr">, {{document.bankAccountNr}}</span>
      <span v-if="document.exportDoc" class="oznaka-ino">INO</span>
    </div>

    <!-- Razrada: otvara se na klik, a sama od sebe kad ima podataka po
         stopama 13 % ili 5 %, u drugoj valuti ili na nabavnoj strani. -->
    <v-btn text small color="primary" class="pl-0 mt-1" @click="razradaOtvorena = !razradaOtvorena" v-if="!prikaziRazradu || !razradaOtvorena">
      <v-icon small>{{ prikaziRazradu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      Razrada po stopama i nabavna strana
    </v-btn>

    <div v-if="prikaziRazradu" class="mt-2">
      <v-divider class="mb-2"></v-divider>

      <div class="par zaglavlje" v-if="!showOnlyEUR">
        <span class="k"></span>
        <span class="v">{{document.documentHomeCurrency}}</span>
        <span class="v2">{{document.documentForeignCurrency}}</span>
      </div>

      <div class="par">
        <span class="k">{{lang.documentTotalVAT1Amount}} {{document.documentTotalVAT1Per}} %</span>
        <span class="v">{{documentTotalVAT1Base}}</span>
        <span class="v2">{{documentTotalVAT1Amount}}</span>
      </div>
      <div class="par" v-if="pNum(documentTotalVAT2Base) !== 0 || pNum(documentTotalVAT2Amount) !== 0">
        <span class="k">{{lang.documentTotalVAT2Amount}} {{document.documentTotalVAT2Per}} %</span>
        <span class="v">{{documentTotalVAT2Base}}</span>
        <span class="v2">{{documentTotalVAT2Amount}}</span>
      </div>
      <div class="par" v-if="pNum(documentTotalVAT3Base) !== 0 || pNum(documentTotalVAT3Amount) !== 0">
        <span class="k">{{lang.documentTotalVAT3Amount}} {{document.documentTotalVAT3Per}} %</span>
        <span class="v">{{documentTotalVAT3Base}}</span>
        <span class="v2">{{documentTotalVAT3Amount}}</span>
      </div>

      <div v-if="!showOnlyEUR">
        <v-divider class="my-2"></v-divider>
        <div class="par">
          <span class="k">{{lang.documentTotalAmountNetto}} ({{document.documentForeignCurrency}})</span>
          <span class="v">{{documentTotalAmountNettoForeign}}</span>
        </div>
        <div class="par">
          <span class="k">{{lang.documentTotalAmountVAT}} ({{document.documentForeignCurrency}})</span>
          <span class="v">{{documentTotalAmountVATForeign}}</span>
        </div>
        <div class="par">
          <span class="k">{{lang.documentTotalAmountBrutto}} ({{document.documentForeignCurrency}})</span>
          <span class="v">{{documentTotalAmountBruttoForeign}}</span>
        </div>
        <div class="par" v-if="pNum(documentTotalAmountDirectD1Foreign) !== 0">
          <span class="k">{{lang.documentTotalAmountDirectD1}} ({{document.documentForeignCurrency}})</span>
          <span class="v">{{documentTotalAmountDirectD1Foreign}}</span>
        </div>
        <div class="par" v-if="pNum(documentTotalAmountPayInAdvanceForeign) !== 0">
          <span class="k">{{lang.documentTotalAmountPayInAdvance}} ({{document.documentForeignCurrency}})</span>
          <span class="v">{{documentTotalAmountPayInAdvanceForeign}}</span>
        </div>
        <div class="par" v-if="docSide != 1">
          <span class="k">{{lang.documentTotalAmountToPay}} ({{document.documentForeignCurrency}})</span>
          <span class="v">{{documentTotalAmountToPayForeign}}</span>
        </div>
      </div>

      <div v-if="docSide === 1">
        <v-divider class="my-2"></v-divider>
        <div class="par">
          <span class="k">{{lang.supplierAmount}}</span>
          <span class="v">{{supplierAmount}}</span>
        </div>
        <div class="par">
          <span class="k">{{lang.supplierDiscount}}</span>
          <span class="v">{{supplierDiscount}}</span>
        </div>
        <div class="par">
          <span class="k">{{lang.supplierNetoAmount}}</span>
          <span class="v">{{supplierNetoAmount}}</span>
        </div>
        <div class="par">
          <span class="k">{{lang.supplierMargin}}</span>
          <span class="v">{{supplierMargin}}</span>
        </div>
      </div>

      <div class="text-right mt-1">
        <v-btn text x-small color="primary" @click="enableSupplier">
          <v-icon x-small>mdi-menu</v-icon>
        </v-btn>
      </div>
    </div>

  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import {  parseNum } from '@/snippets/allSnippets'

export default {
  data() {
    return {
      razradaOtvorena: false,
      document: {},
      lang: {},
      langC: {},
      documentNameLoc: '',
      docSide: 3,
      supplierAmount: 0,
      supplierDiscount: 0,
      supplierNetoAmount: 0,
      supplierMargin: 0,
      documentTotalVAT1Amount: 0,
      documentTotalVAT1Base: 0,
      documentTotalVAT2Amount: 0,
      documentTotalVAT2Base: 0,
      documentTotalVAT3Amount: 0,
      documentTotalVAT3Base: 0,
      documentTotalAmountNetto: 0,
      documentTotalAmountVAT: 0,
      documentTotalAmountDirectD1: 0,
      documentTotalAmountBrutto: 0,
      documentTotalAmountPayInAdvance: 0,
      documentTotalAmountToPay: 0,
      documentTotalAmountNettoForeign: 0,
      documentTotalAmountVATForeign: 0,
      documentTotalAmountDirectD1Foreign: 0,
      documentTotalAmountBruttoForeign: 0,
      documentTotalAmountPayInAdvanceForeign: 0,
      documentTotalAmountToPayForeign: 0,
      showOnlyEUR: true,
      showSupplier: false,
      componentKey: 0
    }
  },
  mounted() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.showOnlyEUR = this.$store.state.businessYear && this.$store.state.businessYear <= 2022 ? false : true
    this.initData()
  },

  methods: {

    initData() {
      if (this.$store.state.documentActivHead) {
        this.document = this.$store.state.documentActivHead
        this.documentNameLoc = this.$store.state.documentActivLoc
      }
      if (this.$store.state.documentSide) {
          this.docSide = this.$store.state.documentSide
        }
      this.supplierAmount = this.document.supplierAmount ? this.formatPrice(this.document.supplierAmount) : 0
      this.supplierDiscount = this.document.supplierDiscount ? this.formatPrice(this.document.supplierDiscount) : 0
      this.supplierNetoAmount = this.document.supplierNetoAmount ? this.formatPrice(this.document.supplierNetoAmount) : 0
      this.supplierMargin = this.document.supplierMargin ? this.formatPrice(this.document.supplierMargin) : 0

      this.documentTotalVAT1Base = this.document.documentTotalVAT1Base ? this.formatPrice(this.document.documentTotalVAT1Base) : 0
      this.documentTotalVAT1Amount = this.document.documentTotalVAT1Amount ? this.formatPrice(this.document.documentTotalVAT1Amount) : 0
      this.documentTotalVAT2Base = this.document.documentTotalVAT2Base ? this.formatPrice(this.document.documentTotalVAT2Base) : 0
      this.documentTotalVAT2Amount = this.document.documentTotalVAT2Amount ? this.formatPrice(this.document.documentTotalVAT2Amount) : 0
      this.documentTotalVAT3Base = this.document.documentTotalVAT3Base ? this.formatPrice(this.document.documentTotalVAT3Base) : 0
      this.documentTotalVAT3Amount = this.document.documentTotalVAT3Amount ? this.formatPrice(this.document.documentTotalVAT3Amount) : 0

      this.documentTotalAmountNetto = this.document.documentTotalAmountNetto ? this.formatPrice(this.document.documentTotalAmountNetto) : 0
      this.documentTotalAmountVAT = this.document.documentTotalAmountVAT ? this.formatPrice(this.document.documentTotalAmountVAT) : 0
      this.documentTotalAmountDirectD1 = this.document.documentTotalAmountDirectD1 ? this.formatPrice(this.document.documentTotalAmountDirectD1) : 0
      this.documentTotalAmountBrutto = this.document.documentTotalAmountBrutto ? this.formatPrice(this.document.documentTotalAmountBrutto) : 0
      this.documentTotalAmountPayInAdvance = this.document.documentTotalAmountPayInAdvance ? this.formatPrice(this.document.documentTotalAmountPayInAdvance) : 0
      this.documentTotalAmountToPay = this.document.documentTotalAmountToPay ? this.formatPrice(this.document.documentTotalAmountToPay) : 0

      this.documentTotalAmountNettoForeign = this.document.documentTotalAmountNettoForeign ? this.formatPrice(this.document.documentTotalAmountNettoForeign) : 0
      this.documentTotalAmountVATForeign = this.document.documentTotalAmountVATForeign ? this.formatPrice(this.document.documentTotalAmountVATForeign) : 0
      this.documentTotalAmountDirectD1Foreign = this.document.documentTotalAmountDirectD1Foreign ? this.formatPrice(this.document.documentTotalAmountDirectD1Foreign) : 0
      this.documentTotalAmountBruttoForeign = this.document.documentTotalAmountBruttoForeign ? this.formatPrice(this.document.documentTotalAmountBruttoForeign) : 0
      this.documentTotalAmountPayInAdvanceForeign = this.document.documentTotalAmountPayInAdvanceForeign ? this.formatPrice(this.document.documentTotalAmountPayInAdvanceForeign) : 0
      this.documentTotalAmountToPayForeign = this.document.documentTotalAmountToPayForeign ? this.formatPrice(this.document.documentTotalAmountToPayForeign) : 0
    },
    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    enableSupplier() {
      this.showSupplier = !this.showSupplier
    },
    pNum(nmb) {
      return parseNum(nmb, 2)
    }
  },
  computed: {
    // Razrada se otvara sama kad ima sto pokazati: stope 13/5 %, druga valuta
    // ili nabavna strana. Inace stoji sklopljena.
    prikaziRazradu () {
      if (this.razradaOtvorena) { return true }
      if (!this.showOnlyEUR) { return true }
      if (this.docSide === 1) { return true }
      return this.pNum(this.documentTotalVAT2Base) !== 0 || this.pNum(this.documentTotalVAT2Amount) !== 0 ||
        this.pNum(this.documentTotalVAT3Base) !== 0 || this.pNum(this.documentTotalVAT3Amount) !== 0
    },

  },
  watch: {

  },
}
</script>

<style>
.fin-kartica .par { display: flex; justify-content: space-between; gap: 10px; padding: 2px 0; }
.fin-kartica .par .k { color: rgba(0,0,0,.6); font-size: 13px; }
.fin-kartica .par .v, .fin-kartica .par .v2 { font-variant-numeric: tabular-nums; text-align: right; min-width: 90px; }
.fin-kartica .par.zaglavlje .v, .fin-kartica .par.zaglavlje .v2 { color: rgba(0,0,0,.6); font-size: 12px; }
.fin-kartica .par.jako .v { font-weight: 700; font-size: 17px; }
.fin-kartica .par.zbroj { border-top: 1px solid rgba(0,0,0,.12); margin-top: 5px; padding-top: 6px; }
.fin-kartica .banka { margin-top: 8px; font-size: 13px; color: rgba(0,0,0,.6); }
.fin-kartica .oznaka-ino { font-weight: 700; color: #1565c0; margin-left: 6px; }


</style>